// 角色权限可视化勾选树的数据源
// 每个分组的 children 中的 value 即存入 role.permissions 的权限标识
export const PERMISSION_TREE = [
  {
    label: '数据统计',
    value: 'dashboard',
    children: [
      { label: '查看统计看板', value: 'dashboard:view' }
    ]
  },
  {
    label: '订单管理',
    value: 'orders',
    children: [
      { label: '订单列表', value: 'orders:view' },
      { label: '订单详情', value: 'orders:detail' },
      { label: '收费规则', value: 'orders:fee-rules' },
      { label: '服务费分配规则', value: 'orders:commission-allocation-rules' }
    ]
  },
  {
    label: '用户管理',
    value: 'user',
    children: [
      { label: '用户列表', value: 'user:users' },
      { label: '用户详情', value: 'user:users-detail' },
      { label: '跑手列表', value: 'user:runners' },
      { label: '跑手详情', value: 'user:runners-detail' },
      { label: '商家列表', value: 'user:shops' },
      { label: '商家编辑', value: 'user:shops-edit' },
      { label: '店家推广人列表', value: 'user:shop-referrers' },
      { label: '跑手推广人列表', value: 'user:runner-referrers' },
      { label: '小区代理列表', value: 'user:community-agents' }
    ]
  },
  {
    label: '物品管理',
    value: 'products',
    children: [
      { label: '物品分类', value: 'products:categories' },
      { label: '物品列表', value: 'products:list' },
      { label: 'SKU 管理', value: 'products:sku' }
    ]
  },
  {
    label: '小区管理',
    value: 'communities',
    children: [
      { label: '小区列表', value: 'communities:view' },
      { label: '小区详情', value: 'communities:detail' },
      { label: '楼栋管理', value: 'communities:buildings' }
    ]
  },
  {
    label: '文章管理',
    value: 'articles',
    children: [
      { label: '文章分类', value: 'articles:categories' },
      { label: '文章列表', value: 'articles:list' }
    ]
  },
  {
    label: '素材库',
    value: 'media',
    children: [
      { label: '素材管理', value: 'media:view' }
    ]
  },
  {
    label: '服务类型管理',
    value: 'service_type',
    children: [
      { label: '服务类型管理', value: 'service_type:view' }
    ]
  },
  {
    label: '数据报表',
    value: 'statistics',
    children: [
      { label: '报表查看', value: 'statistics:view' }
    ]
  },
  {
    label: '钱包流水',
    value: 'finance',
    children: [
      { label: '交易流水', value: 'finance:transactions' },
      { label: '提现审核', value: 'finance:withdraws' }
    ]
  },
  {
    label: '店家钱包',
    value: 'shop-wallet',
    children: [
      { label: '充值审核', value: 'shop-wallet:recharge-audit' }
    ]
  },
  {
    label: '管理员管理',
    value: 'admin-accounts',
    children: [
      { label: '管理员列表', value: 'admin-accounts:list' },
      { label: '新增管理员', value: 'admin-accounts:create' },
      { label: '编辑管理员', value: 'admin-accounts:edit' },
      { label: '角色管理', value: 'admin-accounts:roles' }
    ]
  },
  {
    label: '系统设置',
    value: 'system',
    children: [
      { label: '系统设置', value: 'system:view' }
    ]
  }
]

// 扁平化所有叶子权限 value，便于校验
export const ALL_PERMISSION_VALUES = PERMISSION_TREE.reduce((acc, group) => {
  group.children.forEach((c) => acc.push(c.value))
  return acc
}, [])
